import {
  Box,
  Typography,
  Card,
  Grid,
} from "@mui/material";
import {
  BusinessOutlined,
  GroupOutlined,
  GavelOutlined,
  ShoppingCartOutlined,
  ChevronRight,
  ShoppingBagOutlined,
  SettingsOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import styles from "./style";
import color from "../../../constants/color";

const SettingHome = () => {
  const navigate = useNavigate();

  const organizationItems = [
    { id: "orgProfile", label: "Organization Profile", active: true, path: '/dashboard/settings/organizeProfile' },
    { id: "branding", label: "Branding", active: false, path: '/dashboard/settings/branding' },
    { id: "balances", label: "Opening Balances", active: false },
  ];

  const userItems = [
    { id: "users", label: "Users", active: false },
    { id: "roles", label: "Roles", active: false },
    { id: "rolesAndPermissions", label: "Roles and Permissions", active: true, path: "/dashboard/rolesAndPermissions" },
    { id: "communicationCenter", label: "Communication Center", active: false, path: "/dashboard/communicationCenter" },
  ];

  const taxItems = [
    { id: "taxes", label: "Taxes", active: false },
    { id: "directTaxes", label: "Direct Taxes", active: false },
    { id: "msme", label: "MSME Settings", active: false },
  ];

  const salesItems = [
    { id: "quotes", label: "Quotes", active: false },
    { id: "salesOrders", label: "Sales Orders", active: false },
    { id: "invoices", label: "Invoices", active: false },
    { id: "recurringInvoices", label: "Recurring Invoices", active: false },
  ];

  const purchaseItem = [
    { id: "purchaseOrders", label: "Purchase Orders", active: false },
  ];

  const settingsItems = [
    { id: "customerAndVendors", label: "Customer and Vendors", active: false },
  ];

  const renderCard = (title, icon, items) => (
    <Card sx={styles.card}>
      <Box sx={styles.header}>
        <Box sx={styles.headerIcon}>{icon}</Box>
        <Typography sx={styles.headerTitle}>{title}</Typography>
      </Box>
      {items.map((item) => (
        <Box
          key={item.id}
          sx={{
            ...styles.menuItem,
            ...(item.active && styles.menuItemActive),
          }}
          onClick={() => item.path && navigate(item.path)}
        >
          <Typography
            sx={{
              ...styles.menuText,
              color: item.active ? color.text : color.lightText,
              fontWeight: item.active ? 600 : 400,
            }}
          >
            {item.label}
          </Typography>
          {item.active && <ChevronRight sx={styles.chevronIcon} />}
        </Box>
      ))}
    </Card>
  );

  return (
    <Box sx={styles.container}>
      {/* <Box>
        <Typography sx={styles.heading}>All Settings</Typography>
      </Box>
      <Box sx={styles.filterSection}>
        <Box sx={styles.searchContainer}>
          <input
            type="text"
            placeholder="Search"
            style={styles.searchInput}
          />
        </Box>
      </Box> */}
      <Grid container spacing={3} mb={5}>
        <Grid item xs={12} md={3}>
          {renderCard("Organization", <BusinessOutlined sx={{ color: color.primary }} />, organizationItems)}
        </Grid>
        <Grid item xs={12} md={3}>
          {renderCard("Users & Roles", <GroupOutlined sx={{ color: color.primary }} />, userItems)}
        </Grid>
        <Grid item xs={12} md={3}>
          {renderCard("Taxes & Compliance", <GavelOutlined sx={{ color: color.primary }} />, taxItems)}
        </Grid>
        <Grid item xs={12} md={3}>
          {renderCard("Sales", <ShoppingCartOutlined sx={{ color: color.primary }} />, salesItems)}
        </Grid>
      </Grid>
      <Grid container spacing={3} mb={5}>
        <Grid item xs={12} md={3}>
          {renderCard("Purchases", <ShoppingBagOutlined sx={{ color: color.primary }} />, purchaseItem)}
        </Grid>
        <Grid item xs={12} md={3}>
          {renderCard("Perferences", <SettingsOutlined sx={{ color: color.primary }} />, settingsItems)}
        </Grid>
      </Grid>
    </Box>
  );
};

export default SettingHome;
